import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=d1082da2&scoped=true&"
import script from "./Archives.vue?vue&type=script&lang=js&"
export * from "./Archives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1082da2",
  null
  
)

export default component.exports